import { ComplianceRepository } from "../../repositories/ComplianceRepository";

export class DeleteCalendarEntryUseCase {
  constructor(private repository: ComplianceRepository) {}

  async execute(id: number): Promise<void> {
    if (!id) {
      throw new Error("Calendar entry ID is required");
    }

    return await this.repository.deleteCalendarEntry(id);
  }
}

